const Card = ({
  icons,
  title,
  content,
  contentTwo,
  className,
  iconClassName,
  titleClassName,
  contentClassName,
  contentTwoClassName,
}) => {
  return (
    <div
      className={`px-[2.5rem] py-[2rem] rounded-[1.25rem] bg-white shadow-xl ${className}`}
    >
      {icons && (
        <div className={`w-[6rem] ${iconClassName} `}>
          <img src={icons} alt={title} className="w-fit  " />
        </div>
      )}
      <div className="mt-[2.25rem]">
        <h5
          className={`text-[1.25rem] font-medium font-montserrat ${titleClassName} `}
        >
          {title}
        </h5>
        <div className="">
          <p
            className={`text-[1rem] w-[15rem] mt-[0.8rem] font-gothic ${contentClassName}`}
          >
            {content}
          </p>
          {contentTwo && (
            <p
              className={`text-[0.8rem] text-[#767d88]  w-fit  font-gothic ${contentTwoClassName}`}
            >
              {contentTwo}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default Card
